const InfosAlertYearDisabled = () => {
  return (
    <div className="card border-0 ">
      <div className="alert alert-danger border border-danger mb-0 p-1">
        <div className="d-flex align-items-start">
          <div className="me-2">
            <i className="feather-info flex-shrink-0" />
          </div>
          <div className="text-danger w-100">
            <div className="fw-semibold d-flex justify-content-between">
              Année académique Inactive
              <button
                type="button"
                className="btn-close p-0"
                data-bs-dismiss="alert"
                aria-label="Close"
              >
                <i className="fas fa-xmark" />
              </button>
            </div>
            <div className="fs-12 op-8 mb-1">
              Certaines fonctionnalités peuvent être désactivées.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfosAlertYearDisabled;
